<div [formGroup]="form">
  <div class="row">
    <div class="col-12">
      <label class="me-3">Yearly totals as of the end of </label>
      <lib-month-picker formControlName="asOfDate"></lib-month-picker>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <lib-checkbox
        [size]="checkboxSizes.Small"
        formControlName="displayClientAndEmployeeSetupInfo"
        [label]="'Display Client & Employee setup information.'"
        [id]="'setupInfoChk'">
      </lib-checkbox>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <lib-checkbox
        [size]="checkboxSizes.Small"
        formControlName="includeEmployeeTotals"
        [label]="'Include Employee Totals'"
        [id]="'employeeTotals'"></lib-checkbox>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <lib-checkbox
        [size]="checkboxSizes.Small"
        formControlName="includeClientTotals"
        [label]="'Include Client Totals'"
        [id]="'clientTotals'"></lib-checkbox>
    </div>
  </div>
  <div class="row" *ngIf="form.errors?.['atLeastOneCheckbox']">
    <div class="col-12">
      <p class="error-text">You must select at least one item.</p>
    </div>
  </div>
  <lib-report-buttons
    [formats]="formats"
    [disabled]="form.invalid"
    (generateReport)="generateReport()"
    (downloadReport)="downloadReport($event)"></lib-report-buttons>
</div>
